import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import Avatar from "../../common/Avatar";
import {
  Badge,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { checkUserToken } from "../../../helpers/api/auth";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faUser } from "@fortawesome/free-regular-svg-icons";
import { Or } from "../../UI/preloading/PreloadState";
import moment from "moment";

const Notification = ({
  index,
  to,
  author,
  time,
  className,
  unread,
  flush,
  title,
  closed,
}) => {
  const { token } = useSelector((state) => state.auth.user);
  const location = useLocation();
  const [profile, setProfile] = useState({
    data: false,
    isLoading: true,
    error: false,
  });
  const { firstname } = author;

  useEffect(() => {
    if (author === "me") {
      if (token) {
        const getProfile = async () => {
          try {
            const { data } = await checkUserToken(token);
            setProfile((prev) => {
              return { ...prev, data: data, isLoading: false };
            });
          } catch (e) {
            setProfile((prev) => {
              return { ...prev, error: e, isLoading: false };
            });
          }
        };
        getProfile();
      }
    }
  }, [author, token]);

  return (
    <div
      style={{ background: index % 2 === 1 ? "#efefef" : "#fff" }}
      className={classNames(
        "notification shadow-none border-top rounded-0",
        { "bg-200": unread, "notification-flush": flush },
        className
      )}
    >
      <Row className="w-100">
        <Col>
          <div className="d-flex">
            <div className="notification-avatar">
              <Or cond={author === "me"}>
                <Or value={true} cond={!!profile?.data?.image}>
                  <Or value={true}>
                    <Avatar
                      src={
                        profile?.data?.image
                          ? profile?.data?.image
                          : undefined
                      }
                      className="mr-3"
                    />
                  </Or>
                  <Or value={false}>
                    <Avatar className="mr-3" />
                  </Or>
                </Or>
                <Or value={false} cond={!!author.image}>
                  <Or value={true}>
                    <Avatar
                      src={
                         author.image
                      }
                      className="mr-3"
                    />
                  </Or>
                  <Or value={false}>
                    <Avatar className="mr-3" />
                  </Or>
                </Or>
              </Or>
            </div>
            <div className="notification-body">
              <Row className="justify-content-start align-items-center pl-3">
                <Col>
                  <h5 className="d-flex justify my-0 py-1">{title}</h5>
                  <span className="text-primary">
                    <FontAwesomeIcon icon={faUser} className="mr-1" />
                    {author === "me" ? "Tú" : firstname} •{" "}
                    {closed ? (
                      <Badge pill color="soft-dark">
                        Caso cerrado
                      </Badge>
                    ) : (
                      <Badge pill color="soft-primary">
                        Caso abierto
                      </Badge>
                    )}
                  </span>
                  <br />
                  <span className="notification-time">
                    <FontAwesomeIcon icon={faClock} className="mr-1" />
                    {moment(time).from(new Date())}
                  </span>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        <Col xs="auto" className="d-sm-flex align-items-center">
          <UncontrolledDropdown
            direction="left"
            className="d-inline-block ml-2"
          >
            <DropdownToggle color="falcon-default" size="sm">
              <FontAwesomeIcon icon="ellipsis-h" />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem tag={Link} to={`${location.pathname}/${to}`}>
                Ver detalles
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Col>
      </Row>
    </div>
  );
};

Notification.propTypes = {
  author: PropTypes.any,
  className: PropTypes.string,
  children: PropTypes.node,
};

Notification.defaultProps = { unread: false, flush: false };

export default Notification;
